
export default function Hero() {
  return (
    <section className="relative bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white py-20">
      <div className="absolute inset-0 bg-[url('https://public.readdy.ai/ai/img_res/8d37c301377553ab6a88a464f1f323ea.jpg')] bg-cover bg-center opacity-10"></div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h1 className="text-4xl md:text-5xl font-bold mb-6">견적 문의</h1>
        <p className="text-xl text-slate-300 max-w-3xl mx-auto">
          목형 제작부터 레이저 가공까지, 전문가가 신속하게 견적을 안내해드립니다
        </p>
      </div>
    </section>
  );
}
